export default __webpack_public_path__ + "static/media/NSI.00d84353.png";